import { inject, Service } from '@angular/core';
import { IKidsDruckAnforderung } from '@mng/mgs-lib';
import { firstValueFrom } from 'rxjs';
import { MgsWebApi } from '../mgs-webapi.service';

@Service()
export class KidsDruckanforderungService {
  readonly mgsWebApi = inject(MgsWebApi);

  async druckAnforderung(zusage: boolean, terminId?: number, kidId?: number) {
    const anforderung: IKidsDruckAnforderung = {
      terminId,
      kidId,
      zusage
    };
    await firstValueFrom(this.mgsWebApi.kidsDruckAnforderung(anforderung));
  }

  async druckAnforderungKid(zusage: boolean, kidId?: number) {
    return this.druckAnforderung(zusage, undefined, kidId);
  }

  async druckAnforderungTermin(zusage: boolean, terminId: number) {
    return this.druckAnforderung(zusage, terminId, undefined);
  }

  async druckAnforderungAlle(zusage: boolean) {
    return this.druckAnforderung(zusage);
  }
}
